import { EdenredLogin } from './EdenredLogin';
import { Controller, useFormContext } from 'react-hook-form';
import { FormField } from '../../../../../components/form/FormField';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';
import DatePicker from '@rio-cloud/rio-uikit/DatePicker';
import { useEdenredToken } from '../../../../../login/external/edenredUserManager';
import { PaymentPartnerType } from '../../../../../codegen/vehicles';
import ClearableInput from '@rio-cloud/rio-uikit/ClearableInput';
import moment, { Moment } from 'moment';
import { isMoment } from 'moment/moment';
import { useAppSelector } from '../../../../../state/hooks';
import { getPaymentPartnerType } from '../../../state/onboardingUiSlice';
import { AddNewServiceCardForm } from './AddNewServiceCardForm';

export const ManualInputCardForm = () => {
  const { control, formState, trigger } =
    useFormContext<AddNewServiceCardForm>();

  const edenredToken = useEdenredToken();

  const selectedPaymentPartner = useAppSelector(getPaymentPartnerType);

  const edenredLoginRequired =
    selectedPaymentPartner === PaymentPartnerType.UtaPayment && !edenredToken;

  const errors = formState.errors.cardDetails;

  return (
    <>
      {edenredLoginRequired && <EdenredLogin />}
      <div
        className="col-xs-12"
        data-testid={'onboarding-dialog-body-serviceCardNumberSection'}
      >
        <Controller
          name={'cardDetails.cardNumber'}
          render={({ field: { onChange, value } }) => (
            <FormField
              hasError={!!errors?.cardNumber}
              errorMessage={
                <CustomFormattedMessage
                  id={
                    'onboarding.dialog.serviceCardForm.serviceCardNumber.errorMessage'
                  }
                />
              }
            >
              <label id={'card-number-label'}>
                <CustomFormattedMessage id={'common.card.number'} />
              </label>
              <ClearableInput
                aria-labelledby="card-number-label"
                onChange={(input: string) => {
                  onChange(input);
                  trigger('cardDetails.cardNumber');
                }}
                onBlur={() => {
                  trigger('cardDetails.cardNumber');
                }}
                value={value}
                disabled={edenredLoginRequired}
              />
            </FormField>
          )}
          control={control}
          rules={{
            required: true,
            pattern: /^(\d{17})$/,
          }}
        />
      </div>
      <div
        className="col-xs-12"
        data-testid={'onboarding-dialog-body-serviceCardExpirySection'}
      >
        <Controller
          name={'cardDetails.expiryDate'}
          render={({ field: { onChange } }) => (
            <FormField
              hasError={!!errors?.expiryDate}
              errorMessage={
                <CustomFormattedMessage
                  id={
                    'onboarding.dialog.serviceCardForm.expiryDate.errorMessage'
                  }
                />
              }
            >
              <label id={'card-expiry-label'}>
                <CustomFormattedMessage id={'common.card.expiryDate'} />
              </label>
              <DatePicker
                className={'margin-bottom-0 width-150'}
                dropup
                closeOnSelect
                dateFormat={'MM/YYYY'}
                timeFormat={false}
                onChange={(event: string | Moment) => {
                  if (isMoment(event)) {
                    event = event.format('MM/YYYY');
                  }
                  onChange(event);
                  trigger('cardDetails.expiryDate');
                }}
                inputProps={{
                  disabled: edenredLoginRequired,
                  'aria-labelledby': 'card-expiry-label',
                }}
              />
            </FormField>
          )}
          control={control}
          rules={{
            required: true,
            pattern: /^(0[1-9]|1[012])\/\d{4}$/,
            validate: {
              notInThePast: (date?: string) =>
                moment(date, 'MM/YYYY')
                  .endOf('month')
                  .isAfter(moment().startOf('month')),
            },
          }}
        />
      </div>
    </>
  );
};
